type SocialContent = {
  url: string;
  icon: string;
}

type Socials = "youtube" | "instagram" | "tiktok"

const SOCIALS: Record<Socials, SocialContent> = {
  youtube: {
    url: "https://www.youtube.com/@plaenco",
    icon: "fa-youtube"
  },
  instagram: {
    url: "https://www.instagram.com/plaenco/",
    icon: "fa-instagram"
  },
  tiktok: {
    url: "https://www.tiktok.com/@plaenco",
    icon: "fa-tiktok"
  },
  // twitter: {
  //   url: "https://twitter.com/Plaenco",
  //   icon: "fa-twitter"
  // }
}

export const SOCIAL = Object.entries(SOCIALS).map(([label, content]) => ({
  label,
  ...content
}))